module.exports = __webpack_public_path__ + "static/Group 2927@2x-007dd7917b3b52dd1a1697bef3ed6c3e.png";